import React, {useMemo, useRef, useState} from 'react';
import {AutoComplete, Input} from 'antd';
import OpenTextQuestion from './OpenTextQuestion';
import {t} from '../../../services/i18n';

const SmartTextQuestion = ({question, value, onChange, error, disabled}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [pickedTexts, setPickedTexts] = useState([]);
    const isPickingRef = useRef(false);
    const text = value ?? '';
    const currentLine = text.split('\n').pop();

    const options = useMemo(() => {
        const textBeforeCurrentLine = text.slice(0, text.length - currentLine.length);
        const unpickedAnswers = (question.answers ?? []).filter((answer) => !pickedTexts.includes(answer.answer_text));
        const matchingAnswers = isTyping ? unpickedAnswers.filter((answer) => answer.answer_text.toLowerCase().includes(currentLine.toLowerCase())) : unpickedAnswers;
        return matchingAnswers.map((answer) => ({label: answer.answer_text, value: isTyping || !currentLine ? `${textBeforeCurrentLine}${answer.answer_text}` : `${text}\n${answer.answer_text}`}));
    }, [question.answers, pickedTexts, isTyping, text, currentLine]);

    if (disabled) return <OpenTextQuestion value={value} disabled />;

    const changeText = (newText) => {
        onChange(newText);
        setIsTyping(true);
    };

    const pickOption = (selectedValue, option) => {
        setPickedTexts([...pickedTexts, option.label]);
        setIsTyping(false);
        // the list closes after a pick: ignore that close in this same event
        isPickingRef.current = true;
        setTimeout(() => {
            isPickingRef.current = false;
        });
    };

    const changeOpen = (isVisible) => {
        if (!isVisible && isPickingRef.current) return;
        setIsOpen(isVisible);
    };

    // Enter must add a new line, not be taken by the list
    const keepEnterForNewLine = (event) => {
        if (event.key === 'Enter') event.stopPropagation();
    };

    return (
        <AutoComplete style={{width: '100%', height: 'auto'}} value={text} options={options} open={isOpen} filterOption={false} onChange={changeText} onSelect={pickOption} onDropdownVisibleChange={changeOpen} onFocus={() => setIsTyping(false)}>
            <Input.TextArea rows={3} placeholder={t('smartTextPlaceholder')} status={error ? 'error' : null} onClick={() => setIsTyping(false)} onKeyDown={keepEnterForNewLine} />
        </AutoComplete>
    );
};

export default SmartTextQuestion;
